export default "__VITE_PUBLIC_ASSET__19b1437b__"